import React from "react";

const EmptyState = ({ title = "Aucune donnée", description = "Essayez d'ajuster votre recherche ou ajoutez un élément." }) => {
  return (
    <div className="text-center p-5 bg-white border rounded">
      <div style={{ fontSize: 32, lineHeight: 1 }}>📭</div>
      <h6 className="mt-2 mb-1">{title}</h6>
      <p className="text-muted mb-0" style={{ fontSize: 14 }}>{description}</p>
    </div>
  );
};

export default EmptyState;


